import { filter, map, retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionAuth } from "../../auth/actionAuth";
import { actionEventInfoReceived, TypeActionEventInfo } from "./actionEventInfo";
export var epicEventInfo = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionAuth.Login || action.type === TypeActionEventInfo.Request;
    }), switchMap(function (action) {
        var playerId = action.type === TypeActionAuth.Login
            ? action.playerId
            : state$.value.playerInfo.playerId;
        return deps.netSend({
            id: CommandCode.EventInfo,
            props: {
                playerId: playerId,
            },
        });
    }), retry(), map(function (res) { return actionEventInfoReceived(res); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/event/epicEventInfo.ts
// module id = 1902
// module chunks = 3